jQuery(document).ready(function(){

  jQuery('.productView-info-item:first-child .productView-info-name').text('Brand:');


  const featuredSlider = jQuery('#featured-collection-custom');
  
  featuredSlider.slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        centerMode: true,
        prevArrow: false,
         nextArrow: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: true,
         prevArrow: false,
          nextArrow: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
         prevArrow: false,
         nextArrow: false
      }
    }
 
  ]
});

  jQuery('.featured-collection-custom .slick-arrow').text('');
  jQuery('.featured-collection-custom .slick-arrow').append('<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 2048 2048"><path fill="#8dc63f" d="m658 2023l-121-121l878-878l-878-878L658 25l999 999z"/></svg>');

  
  //FAQ accordion
  // jQuery('#faq-accordion').accordion(); 
  // jQuery( "#accordion4" ).accordion();
    
   if(jQuery(window).width() < 1200) {
     jQuery('.featured-collection-custom .slick-cloned').remove();
    }
  
  //Blog Button 
  jQuery('.article-item .blog-btn .text').text('Read More');  
  
  //Blog Single Title remove 
  jQuery('.template-article .page-header').remove();  

  jQuery(document).on('submit','.customer-login-form [type="submit"]', function(){
    alert('yes');
  })

  //Job Breadcrumb
    const value = `<nav class="breadcrumb breadcrumb-" role="navigation" aria-label="breadcrumbs">
      <a class="link home-link" href="/">Home</a>
      <span class="separate" aria-hidden="true">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg>
      </span>
      <a class="link home-link" href="https://www.natures-source.com/pages/job-board">Job Listing</a>
      <span class="separate" aria-hidden="true">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg>
      </span>
      <span>`+ document.querySelector('.main-page-title').innerText +`</span>
      <span class="observe-element" style="width: 1px; height: 1px; background: transparent; display: inline-block; flex-shrink: 0;"></span>
      </nav>`;

  jQuery('.temp-job .custom-breadcrumb .breadcrumb').html(value);
   
  jQuery('.template-product .policies-block').insertBefore('#judgeme_product_reviews');

});


jQuery(document.body).on('click', '#faq-pdp .accordion-header', function(){
  jQuery('#faq-pdp .accordion-body').not(jQuery(this).next()).slideUp();
  jQuery(this).next('#faq-pdp .accordion-body').slideToggle();
  jQuery('#faq-pdp .accordion-header').removeClass('active');
  jQuery(this).addClass('active');
});

// jQuery('.menu-lv-item').hover(function(){
//   jQuery(this).find('.menu-lv-1__action').next().toggleClass('cs-active');
// })




